'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';
import React from 'react'
import PaginationPluto from './Pagination';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useEffect } from 'react';
import { useState } from 'react';
import PlutoMenu from './PlutoMenu';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';

function PlutoPaidCashOffers() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [length, setLength] = useState(0)
    const [rank, setRank] = useState(0)
    const [uid, setUID] = useState(-1)
    const [alert, setAlert] = useState({ show: false, type: '', flagReason: '', code: '', pin: '', id: -1 })
    const [alert2, setAlert2] = useState({ show: false, name: '', reward: 0 })
    useEffect(() => {
        socket.on('response_get_admin_paidcashoffers', (data) => {
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 10))
            setLength(data.withdrawalsLength)
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)

        })
        socket.emit('getPaidCashOffersAdminToday', {
            username_like: username,
            page,
        })
    }, [])

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <SweetAlert
                show={alert2.show}
                closeOnClickOutside={false}

                onConfirm={function () {
                    socket.emit('adminAction', {
                        action: 'addPaidCashOffer',
                        page: page,
                        dataOffer: { ...alert2 }
                    })
                    setAlert2({ show: false, name: '', reward: 0 })
                }}
                style={{ backgroundColor: '#161b22', color: '#e6edf3', border: '1px solid #30363d' }}
                cancelBtnText="Not now"
                confirmBtnText="Edit"
                showCancel={true}
                cancelBtnStyle={{ color: '#8b949e', textDecoration: 'none', background: '#21262d', border: '1px solid #30363d', borderRadius: '8px', padding: '6px 16px' }}
                confirmBtnStyle={{ border: '1px solid #2ea043', boxShadow: 'none', padding: '6px 16px', backgroundColor: '#238636', borderRadius: '8px', color: '#ffffff' }}
                onCancel={function () { setAlert2({ show: false, name: '', reward: 0 }) }}
            >
                <>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>

                        <p style={{ width: '100%', textAlign: 'left', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', fontWeight: 500 }}>Name</p>
                        <input placeholder={'name'} name="input-name" onChange={(e) => {
                            setAlert2({ ...alert2, name: e.currentTarget.value })
                        }} type={'text'} className="input_field" style={{
                            background: '#0d1117',
                            border: '1px solid #30363d',
                            borderRadius: '8px',
                            color: '#e6edf3',
                            padding: '8px 12px',
                            outline: 'none',
                            marginBottom: '12px',
                            width: '100%'
                        }} />
                        <p style={{ width: '100%', textAlign: 'left', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', fontWeight: 500 }}>Reward</p>
                        <input placeholder={'reward'} name="input-name" onChange={(e) => {
                            setAlert2({ ...alert2, reward: e.currentTarget.value })
                        }} type={'text'} className="input_field" style={{
                            background: '#0d1117',
                            border: '1px solid #30363d',
                            borderRadius: '8px',
                            color: '#e6edf3',
                            padding: '8px 12px',
                            outline: 'none',
                            width: '100%'
                        }} />
                    </div>
                </>

            </SweetAlert>
            <SweetAlert
                closeOnClickOutside={false}

                show={alert.show}
                onConfirm={function () {
                    socket.emit('adminAction', {
                        action: 'editPaidCashOffer',
                        id: alert.id,
                        page: page,
                        dataOffer: { ...alert }
                    })
                    setAlert({ show: false, type: '', flagReason: '', code: '', pin: '', id: -1 })
                }}
                style={{ backgroundColor: '#161b22', color: '#e6edf3', border: '1px solid #30363d' }}
                cancelBtnText="Not now"
                confirmBtnText="Edit"
                showCancel={true}
                onClickOutside={() => { }}
                cancelBtnStyle={{ color: '#8b949e', textDecoration: 'none', background: '#21262d', border: '1px solid #30363d', borderRadius: '8px', padding: '6px 16px' }}
                confirmBtnStyle={{ border: '1px solid #2ea043', boxShadow: 'none', padding: '6px 16px', backgroundColor: '#238636', borderRadius: '8px', color: '#ffffff' }}
                onCancel={function () { setAlert({ show: false }) }}
            >
                <>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {Object.keys(alert).map((x, i) => {
                            if (x != 'show') {
                                if (x != 'id') {
                                    return <>
                                        <p style={{ width: '100%', textAlign: 'left', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', fontWeight: 500 }}>{x}</p>
                                        <input placeholder={x} name="input-name" onChange={(e) => {
                                            setAlert({ ...alert, [x]: e.currentTarget.value })
                                        }} defaultValue={Object.values(alert)[i]} type={'text'} className="input_field" style={{
                                            background: '#0d1117',
                                            border: '1px solid #30363d',
                                            borderRadius: '8px',
                                            color: '#e6edf3',
                                            padding: '8px 12px',
                                            outline: 'none',
                                            marginBottom: '12px',
                                            width: '100%'
                                        }} />
                                    </>
                                }
                            }
                        })}
                    </div>
                </>

            </SweetAlert>

            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>
                {/* Stats Card */}
                <div style={{ marginBottom: '24px' }}>
                    {length != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #14b8a6',
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'inline-block',
                            minWidth: '160px'
                        }}>
                            <p style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#e6edf3',
                                margin: 0,
                                marginBottom: '4px'
                            }}>
                                {numberWithCommas(length)}
                            </p>
                            <p style={{
                                color: '#8b949e',
                                fontSize: '11px',
                                fontWeight: 500,
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px',
                                margin: 0
                            }}>Total Direct Offers</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Add New Button */}
                <div onClick={() => {
                    setAlert2({ show: true, name: '', reward: 0 })
                }} style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '6px 16px',
                    background: '#238636',
                    border: '1px solid #2ea043',
                    borderRadius: '8px',
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    marginBottom: '16px'
                }}
                    onMouseEnter={(e) => e.target.style.background = '#2ea043'}
                    onMouseLeave={(e) => e.target.style.background = '#238636'}
                >Add new</div>

                {/* Main Table Card */}
                <div style={{
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    {/* Card Header */}
                    <div style={{
                        padding: '16px 20px',
                        borderBottom: '1px solid #21262d'
                    }}>
                        <p style={{ color: '#e6edf3', fontWeight: 600, fontSize: '16px', margin: 0 }}>Users</p>
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ background: '#161b22' }}>
                                    <th style={{ minWidth: '50px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>ID</th>
                                    <th style={{ minWidth: '200px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Name</th>
                                    <th style={{ minWidth: '100px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Reward</th>
                                    <th style={{ minWidth: '100px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Offer ID</th>
                                    <th style={{ minWidth: '100px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Enabled</th>
                                    <th style={{ minWidth: '100px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Sticky</th>
                                    <th style={{ minWidth: '300px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {earnings.map((earning, i) => {
                                    return (
                                        <tr
                                            key={earning.id || i}
                                            style={{
                                                borderBottom: '1px solid #21262d',
                                                transition: 'background 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = '#1c2128'}
                                            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        >
                                            <td style={{ minWidth: '50px', color: '#8b949e', padding: '14px 16px', fontSize: '13px' }}>{earning.id == undefined ? '' : earning.id || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '200px', textOverflow: 'ellipsis', overflow: 'hidden', color: '#e6edf3', padding: '14px 16px', fontSize: '13px' }}>{earning.name || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '100px', color: '#3fb950', fontWeight: 500, padding: '14px 16px', fontSize: '13px' }}>{earning.reward || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '100px', color: '#c9d1d9', padding: '14px 16px', fontSize: '13px' }}>{earning.offer_id || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '100px', padding: '14px 16px', fontSize: '13px' }}>
                                                <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '9999px',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    background: earning.enabled == true ? 'rgba(63,185,80,0.15)' : 'rgba(248,81,73,0.15)',
                                                    color: earning.enabled == true ? '#3fb950' : '#f85149'
                                                }}>
                                                    {earning.enabled == true ? 'yes' : 'no'}
                                                </span>
                                            </td>
                                            <td style={{ minWidth: '100px', padding: '14px 16px', fontSize: '13px' }}>
                                                <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '9999px',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    background: earning.sticky == true ? 'rgba(210,153,34,0.15)' : 'rgba(139,148,158,0.1)',
                                                    color: earning.sticky == true ? '#d29922' : '#8b949e'
                                                }}>
                                                    {earning.sticky == true ? 'yes' : 'no'}
                                                </span>
                                            </td>
                                            <td style={{ minWidth: '300px', padding: '14px 16px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                <div onClick={() => {
                                                    socket.emit('adminAction', {
                                                        action: 'doEnableOfferPaidCash',
                                                        id: earning.id,
                                                        page: page,
                                                    })
                                                }} style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 12px',
                                                    background: earning.enabled == true ? 'rgba(248,81,73,0.15)' : 'rgba(63,185,80,0.15)',
                                                    border: earning.enabled == true ? '1px solid rgba(248,81,73,0.3)' : '1px solid rgba(63,185,80,0.3)',
                                                    borderRadius: '8px',
                                                    color: earning.enabled == true ? '#f85149' : '#3fb950',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    cursor: 'pointer',
                                                    transition: 'opacity 0.2s',
                                                    minWidth: '80px'
                                                }}>{earning.enabled == true ? "Disable" : "Enable"}</div>
                                                <div onClick={() => {
                                                    socket.emit('adminAction', {
                                                        action: 'doStickyOfferPaidCash',
                                                        id: earning.id,
                                                        page: page,
                                                    })
                                                }} style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 12px',
                                                    background: earning.sticky == true ? 'rgba(210,153,34,0.15)' : 'rgba(139,148,158,0.1)',
                                                    border: earning.sticky == true ? '1px solid rgba(210,153,34,0.3)' : '1px solid rgba(139,148,158,0.2)',
                                                    borderRadius: '8px',
                                                    color: earning.sticky == true ? '#d29922' : '#8b949e',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    cursor: 'pointer',
                                                    transition: 'opacity 0.2s',
                                                    minWidth: '80px'
                                                }}>{earning.sticky == true ? "DeSticky" : "Sticky"}</div>
                                                <div onClick={() => {
                                                    setAlert({ show: true, ...earning })
                                                }} style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 12px',
                                                    background: '#21262d',
                                                    border: '1px solid #30363d',
                                                    borderRadius: '8px',
                                                    color: '#e6edf3',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    cursor: 'pointer',
                                                    transition: 'background 0.2s',
                                                    minWidth: '80px'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.background = '#30363d'}
                                                    onMouseLeave={(e) => e.target.style.background = '#21262d'}
                                                >Edit</div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}
                <div style={{ marginBottom: '16px' }}>
                    {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        setPage(page)
                        socket.emit('getPaidCashOffersAdminToday', {
                            username_like: username,
                            page,
                        })
                    }} />}
                </div>

                {/* Jump to Page */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                    <input onKeyDown={
                        (e) => {
                            if (e.key == 'Enter') {
                                canUsePagination(false)
                                setEarnings([0, 0, 0, 0, 0])
                                socket.emit('getPaidCashOffersAdminToday', {
                                    username_like: username,
                                    page: document.getElementById('jumpto3dpaidcashoffers').value,
                                })
                            }
                        }
                    } type="number" id="jumpto3dpaidcashoffers" style={{
                        background: '#0d1117',
                        border: '1px solid #30363d',
                        borderRadius: '8px',
                        color: '#e6edf3',
                        padding: '8px 12px',
                        fontSize: '13px',
                        outline: 'none',
                        width: '80px'
                    }}
                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                    />
                    <button onClick={() => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        socket.emit('getPaidCashOffersAdminToday', {
                            username_like: username,
                            page: document.getElementById('jumpto3dpaidcashoffers').value,
                        })
                    }
                    } style={{
                        color: '#ffffff',
                        background: '#238636',
                        border: '1px solid #2ea043',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        fontSize: '13px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                    }}
                        onMouseEnter={(e) => e.target.style.background = '#2ea043'}
                        onMouseLeave={(e) => e.target.style.background = '#238636'}
                    >Go to page</button>
                </div>
            </div>

        </SkeletonTheme>
    )
}

export default PlutoPaidCashOffers
